var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.875C8.62445 0.875 10.1824 1.52031 11.331 2.66897C12.4797 3.81763 13.125 5.37555 13.125 7C13.125 8.62445 12.4797 10.1824 11.331 11.331C10.1824 12.4797 8.62445 13.125 7 13.125C5.37555 13.125 3.81763 12.4797 2.66897 11.331C1.52031 10.1824 0.875 8.62445 0.875 7C0.875 5.37555 1.52031 3.81763 2.66897 2.66897C3.81763 1.52031 5.37555 0.875 7 0.875ZM6.237 8.20837L4.87638 6.84687C4.8276 6.7981 4.76969 6.7594 4.70596 6.73301C4.64223 6.70661 4.57392 6.69302 4.50494 6.69302C4.43596 6.69302 4.36765 6.70661 4.30392 6.73301C4.24019 6.7594 4.18228 6.7981 4.1335 6.84687C4.03499 6.94539 3.97965 7.079 3.97965 7.21831C3.97965 7.35763 4.03499 7.49124 4.1335 7.58975L5.866 9.32225C5.91464 9.37128 5.9725 9.41019 6.03625 9.43674C6.1 9.4633 6.16838 9.47697 6.23744 9.47697C6.3065 9.47697 6.37487 9.4633 6.43862 9.43674C6.50237 9.41019 6.56024 9.37128 6.60887 9.32225L10.1964 5.73387C10.2458 5.6853 10.2851 5.62742 10.3121 5.56357C10.339 5.49972 10.3531 5.43117 10.3534 5.36187C10.3537 5.29256 10.3403 5.22388 10.314 5.15979C10.2876 5.09569 10.2488 5.03745 10.1998 4.98841C10.1509 4.93938 10.0927 4.90053 10.0286 4.8741C9.96454 4.84767 9.89587 4.83419 9.82657 4.83443C9.75727 4.83467 9.6887 4.84863 9.62482 4.8755C9.56094 4.90237 9.50301 4.94163 9.45438 4.991L6.237 8.20837Z",
    fill: "#46A14B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.dd202fdbb72d5717282a0110fd3cc0ff.svg";
export { ForwardRef as ReactComponent };